import React, { useState, useRef } from "react";
import Icons from "../../../../Constants/Icons";
import { apiCallDeleteEventMedia } from "../../../../Core/Apicall";
import { useDispatch } from "react-redux";
import {
  setLoadingFalse,
  setLoadingTrue,
} from "../../../../Config/Actions/loadingActions";
import EmptyData from "../../../../Components/EmptyData/EmptyData";

const MediaDetails = ({ mediaDetalisData, onDeleteMedia }) => {
  const [isPlaying, setIsPlaying] = useState({});
  const videoRefs = useRef({});
  const dispatch = useDispatch();

  const handlePlay = (id) => {
    const videoRef = videoRefs.current[id];
    if (videoRef) {
      videoRef.play();
      setIsPlaying((prevState) => ({
        ...prevState,
        [id]: true,
      }));
    }
  };

  const handlePause = (id) => {
    const videoRef = videoRefs.current[id];
    if (videoRef) {
      videoRef.pause();
      setIsPlaying((prevState) => ({
        ...prevState,
        [id]: false,
      }));
    }
  };

  const handleDelete = async (data) => {
    dispatch(setLoadingTrue());
    const param = { eventId: data.eventId, mediaId: data._id };
    try {
      const res = await apiCallDeleteEventMedia(param);
      onDeleteMedia(data);
      dispatch(setLoadingFalse());
    } catch (error) {
      dispatch(setLoadingFalse());
    }
  };

  return (
    <div
      className=" achievement-container"
      style={{ flexWrap: "wrap", flexDirection: "inherit" }}
    >
      <div className="media-flex">Media details</div>

      {mediaDetalisData.length === 0 ? (
        <div className="empty-centered">
          <EmptyData />
        </div>
      ) : (
        mediaDetalisData?.map((media) => (
          <div className="media-item" key={media.id}>
            {media?.thumbnailUrl === null ? (
              <div className="media-thumbnail">
                <img
                  src={media.mediaUrl}
                  alt="User Media"
                  className="media-image"
                />
                <img
                  className="delete-icon"
                  src={Icons.delete}
                  onClick={() => handleDelete(media)}
                  alt="Delete Icon"
                />
              </div>
            ) : (
              <div className="media-video">
                <video
                  src={media.mediaUrl}
                  loop
                  ref={(el) => (videoRefs.current[media.id] = el)}
                  className="video-element"
                />

                <img
                  className="delete-icon"
                  src={Icons.delete}
                  onClick={() => handleDelete(media)}
                  alt="Delete Icon"
                />
                {!isPlaying[media.id] ? (
                  <div
                    className="play-button"
                    onClick={() => handlePlay(media.id)}
                  >
                    <img src={Icons.playButton} alt="Play Button" />
                  </div>
                ) : (
                  <div
                    className="pause-overlay"
                    onClick={() => handlePause(media.id)}
                  ></div>
                )}
              </div>
            )}
          </div>
        ))
      )}
    </div>
  );
};

export default MediaDetails;
